import { asCorporateBondId } from "@goodfill/domain-properties";
import { useParams } from "react-router-dom";
import { Span } from "../../../../ui-components";
import { PortfolioPositions } from "./PortfolioPositions";

export const PortfolioPositionsSection = () => {
  const { bondId: bondIdParam } = useParams();
  const bondId = bondIdParam ? asCorporateBondId(bondIdParam) : null;

  return (
    <div className="flex flex-col my-2 mx-8 px-8 gap-8 w-full">
      <Span font="semibold" size="lg">
        <>Positions for bond {bondId}</>
      </Span>

      {bondId !== null ? <PortfolioPositions bondId={bondId} /> : null}
    </div>
  );
};
